import {Card} from "../../../../components/card/card.jsx";
import InputDatetime from "../../../../components/input/input-datetime.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import SentryRow from "../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaSearch} from "react-icons/fa";
import {garrisonTimelineFilters} from "../utils/garrison-timeline-utils.js";
import ReportUtils from "../../../../utils/report-utils.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const GarrisonTimelineFilters = ({filters, setFilters, setAppliedFilters, leaders, teams, contingent}) => {
  const handleInput = useGeneralInputSpecialCase(setFilters);

  const submit = () => {
    setAppliedFilters({
      dtStart: filters.dtStart ? ReportUtils.formatDateTime(filters.dtStart) : null,
      dtEnd: filters.dtEnd ? ReportUtils.formatDateTime(filters.dtEnd) : null,
      leaderId: filters.leaderId || null,
      team: filters.team || null,
      contingent: filters.contingent || null,
    });
  };

  const clear = () => {
    setFilters(garrisonTimelineFilters);
    setAppliedFilters(null);
  };

  useGlobalKey("Enter", submit);
  useGlobalKey("Escape", clear);

  return (
    <Card>
      <Card.Body>
       <SentryRow>
         <InputDatetime
           id="dtStart"
           label="Data/hora inicial *"
           selected={filters.dtStart}
           onChange={date => handleInput("dtStart", date)}
           classNameWrapper="col-span-2"
         />
         <InputDatetime
           id="dtEnd"
           label="Data/hora final *"
           selected={filters.dtEnd}
           onChange={date => handleInput("dtEnd", date)}
           classNameWrapper="col-span-2"
         />
         <SelectComponent
           id="leaderId"
           instanceId="leaderId"
           value={filters.leaderId}
           label="Responsável"
           onChange={select => handleInput("leaderId", select?.value ?? null)}
           options={leaders}
           classNameWrapper="col-span-3"
         />
         <SelectComponent
           id="team"
           instanceId="team"
           value={filters.team}
           label="Equipe"
           onChange={select => handleInput("team", select?.value ?? null)}
           options={teams}
           classNameWrapper="col-span-2"
         />
         <div className="col-span-3 flex gap-4">
           <SelectComponent
             id="contingent"
             instanceId="contingent"
             value={filters.contingent}
             label="Contingente"
             onChange={select => handleInput("contingent", select?.value ?? null)}
             options={contingent}
             classNameWrapper="flex-1"
           />
           <div className="flex gap-2">
             <Button target="primary-outline" title="Limpar" onClick={clear}><FaEraser/></Button>
             <Button title="Buscar" onClick={submit}><FaSearch/></Button>
           </div>
         </div>
       </SentryRow>
      </Card.Body>
    </Card>
  )
}

export default GarrisonTimelineFilters;
